export default {
      id: "ic_chevron_dates-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic_chevron_dates-usage",
      toString: function () {
        return this.url;
      }
    }